<template>
  <div>
    <Map
      v-if="displayMap"
      @homeClick="homeClick"
      @busStopClick="busStopClick"
    ></Map>
    <v-overlay :value="requestingLoading" style="z-index: 100">
      <v-card light style="padding: 20px; width: 100vw"
        ><v-card-text
          ><div class="text-center">
            <v-progress-circular
              indeterminate
              :size="60"
              :width="5"
            ></v-progress-circular
            ><br /><br />
            <v-row
              ><v-col cols="4"
                ><img src="images/taxi.png" alt="" style="width: 100%" /></v-col
              ><v-col cols="8" style="text-align: left"
                >予約受領<br />予約確定までお待ちください。</v-col
              ></v-row
            >
          </div></v-card-text
        ></v-card
      >
    </v-overlay>
    <div v-if="reservation.id != null" class="reservedMsg">
      <v-row
        ><v-col cols="12"
          >予約内容<br />乗車：{{ reservation.location_name }}<br />降車：{{
            reservation.destination_name
          }}<br />予約日時：{{ reserve_at2text(reservation.reserve_at)
          }}<br /><small>※乗合になるため時間が前後いたします。</small></v-col
        ></v-row
      >
      <v-row justify="end"
        ><v-btn
          color="secondary"
          class="mr-2 mb-2"
          @click="canselOrderDialog = true"
          >取消</v-btn
        ></v-row
      >
    </div>
    <div
      class="reservedMsg"
      v-if="
        nowRequesting == false &&
        requestingId == null &&
        reservation.id == null &&
        setNext == false &&
        msgBox == false &&
        markerClickDialog == false
      "
    >
      <v-row
        ><v-col cols="12"
          >乗車場所または降車場所のマーカーをタップしてください。
        </v-col></v-row
      >
    </div>
    <div class="msg" :style="{ display: msgDisplay }">
      <div class="msgTxt" style="white-space: pre-wrap">{{ msgTxt }}</div>
    </div>
    <v-dialog v-model="setHomeMsgDialog" persistent max-width="90vw">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ml-2 mt-2"
          v-if="homeLat == null || homeLon == null"
        >
          設定
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="pt-2"
          >基山町にお住まいの方は自宅を登録してください。</v-card-text
        >
        <v-card-actions>
          <v-row justify="center" class="mb-2"
            ><v-spacer></v-spacer
            ><v-btn
              color="primary"
              @click="
                setHomeMsgDialog = false;
                setHomeMsg = true;
              "
            >
              登録する</v-btn
            ><v-spacer></v-spacer
            ><v-btn
              color="secondary"
              @click="
                setHomeMsgDialog = false;
                homeLat = 0;
                homeLon = 0;
              "
            >
              登録しない</v-btn
            ><v-spacer></v-spacer
          ></v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="setHomeMsg" v-if="setHomeMsg">
      地図をスクロール、拡大／縮小して、センターマーク位置を自宅に登録します。<v-btn
        color="primary"
        @click="
          setHomeMsg = false;
          setHomeDialog = true;
        "
      >
        登録
      </v-btn>
    </div>
    <div class="setHomeMsg" v-if="msgBox">
      {{ msgBoxTxt }}
      <v-btn
        style="float: right"
        class="mt-2"
        color="secondary"
        @click="cancelSetHome()"
        >キャンセル</v-btn
      >
    </div>
    <v-dialog v-model="setHomeDialog" persistent max-width="90vw">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ml-2 mt-2"
          v-if="homeLat == null || homeLon == null"
        >
          設定
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="pt-2"
          >自宅をここに設定してよろしいですか？</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="setHome"> はい </v-btn
          ><v-btn
            color="secondary"
            @click="
              setHomeDialog = false;
              setHomeMsg = true;
            "
          >
            いいえ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="85vw">
      <!--<template v-slot:activator="{ on, attrs }">
          <img
            :src="require('@/assets/call_btn.png')"
            @touchstart="inputNumToRide()"
            v-show="callMobilityBtnDisabled == false"
            v-bind="attrs"
            v-on="on"
            alt=""
            class="call_btn"
            :class="{ animation: isAnim1 }"
          />
        </template>-->
      <v-card>
        <!--<v-card-title class="text-h5" style="font-weight: bold">
            乗車する人数を入力してください。
          </v-card-title>-->
        <v-card-text class="formDialog">
          <v-row style="font-size: 16px" class="pt-6">
            <v-col cols="3">乗車：<br /><br />降車：</v-col>
            <v-col cols="9"
              >{{ getOn }}<br />
              ↓<br />
              {{ getOff }}</v-col
            >
            <!--<v-col cols="3"
              ><v-btn color="primary" @click="swap()" class="mt-4"
                >↑↓</v-btn
              ></v-col
            >-->
          </v-row>
          <v-row>
            <v-col cols="8"
              ><!--<v-select
                v-model="selectedDate"
                item-text="text"
                item-value="value"
                :items="dateList"
                label="年月日*"
                return-object
              />--><v-text-field
                variant="outlined"
                label="当日"
                class="pt-6"
                readonly
                v-model="selectedDateText"
              ></v-text-field>
            </v-col>
            <v-col cols="4"
              ><v-select
                v-model="selectedTime"
                item-text="text"
                item-value="value"
                :items="timeList"
                label="時間*"
                return-object
                class="mt-4"
                no-data-text="予約時間外"
              />
            </v-col>
          </v-row>
          <v-row
            ><v-col cols="6"
              ><v-text-field
                variant="outlined"
                label="お名前*"
                class="pt-6"
                v-model="name"
              ></v-text-field></v-col
            ><v-col cols="6"
              ><v-text-field
                variant="outlined"
                label="携帯番号*"
                class="pt-6"
                v-model="tel"
              ></v-text-field></v-col
          ></v-row>
          <!--<v-row
            ><v-col cols="6"
              ><v-select
                v-model="sex"
                item-text="text"
                item-value="value"
                :items="sexList"
                label="性別"
                return-object /></v-col
            ><v-col cols="6"
              ><v-select
                v-model="age"
                item-text="text"
                item-value="value"
                :items="ageList"
                label="年齢"
                return-object /></v-col
          ></v-row>-->
          <v-row
            ><v-col cols="6"
              ><v-select
                v-model.number="numToRide"
                item-text="title"
                item-value="value"
                :items="numToRideList"
                label="人数*"
                style="width: 20vw" /></v-col
            ><v-col cols="6"
              ><!--<v-text-field
                variant="outlined"
                label="料金"
                class="pt-6"
                v-model="fee"
                readonly
              ></v-text-field>--></v-col
            ></v-row
          >
          <p class="note">*：必須項目</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="
              dialog = false;
              cancelOrder();
            "
            >キャンセル</v-btn
          >
          <v-btn color="primary" @click="orderComfirm()">確認</v-btn>
        </v-card-actions>
      </v-card> </v-dialog
    ><v-dialog v-model="orderComfirmDialog" persistent max-width="90vw">
      <v-card>
        <v-card-title>この内容で予約してよろしいですか？</v-card-title>
        <v-card-text class="pt-2"
          >乗車：{{ getOn }}<br />
          降車：{{ getOff }}<br />
          日時：{{ selectedDateTime }}<br />
          お名前：{{ name }}<br />
          携帯番号：{{ tel }}<br />
          人数：{{ numToRide }}<br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="orderComfirmDialog = false">
            修正 </v-btn
          ><v-btn
            color="primary"
            @click="
              saveNameTel();
              postOrder();
            "
          >
            はい
          </v-btn>
        </v-card-actions>
      </v-card> </v-dialog
    ><v-dialog v-model="markerClickDialog" persistent max-width="90vw">
      <v-card>
        <v-card-title class="markerClickDialogTitle">{{
          markerClickDialogTitle
        }}</v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-1">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="
                markerClickDialog = false;
                markerClickDialogBtn(markerClickDialogTitle, '');
              "
            >
              乗車場所</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="
                markerClickDialog = false;
                markerClickDialogBtn('', markerClickDialogTitle);
              "
            >
              降車場所 </v-btn
            ><v-spacer></v-spacer
          ></v-row>
          <v-row justify="center" class="mt-8">
            <v-btn
              color="primary"
              @click="
                markerClickDialog = false;
                setHomeMsg = true;
                homeLat = null;
                homeLon = null;
              "
              v-show="markerClickDialogTitle == '自宅'"
            >
              自宅位置を変更
            </v-btn></v-row
          ><v-row justify="center" class="mt-8 mb-2">
            <v-btn color="secondary" @click="markerClickDialog = false">
              キャンセル
            </v-btn></v-row
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" persistent max-width="85vw">
      <v-card>
        <v-card-title class="text-h5" style="font-weight: bold">
          乗車する介護者の人数を入力してください。
        </v-card-title>
        <v-card-text class="rideNumInput"
          ><v-btn-toggle class="mt-4" v-model="numKaigo"
            ><v-btn x-large>0<span class="nin">人</span></v-btn
            ><v-btn x-large>1<span class="nin">人</span></v-btn
            ><v-btn x-large>2<span class="nin">人</span></v-btn></v-btn-toggle
          ></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--<v-btn x-large color="primary" @touchstart="callMobility"> 決定 </v-btn>-->
          <img
            :src="require('@/assets/cancel_btn.png')"
            @touchstart="
              //playBtnSe();
              dialog2 = false;
              numToRideSelected = 0;
              numKaigo = 0;
            "
            alt=""
            class="fix_btn mr-4"
          />
          <img
            :src="require('@/assets/fix_btn.png')"
            @touchstart="
              //playBtnSe();
              callMobility2()
            "
            alt=""
            class="fix_btn"
            :class="{ animation: isAnim2 }"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="timeoutDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5" style="font-weight: bold; padding: 25px">
          現在呼び出せる車両がございません。<br />時間をおいてから再度お試しください。
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="canselOrderDialog"
      persistent
      max-width="90vw"
      style="z-index: 110"
    >
      <v-card>
        <v-card-text class="pt-2">本当に取消してよろしいですか？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="deleteOrder"> はい </v-btn
          ><v-btn color="secondary" @click="canselOrderDialog = false">
            いいえ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="ctr" style="display: none">
      {{ btmMsg }}

      <br />
      <!--<v-btn block x-large class="wide-btn" style="display: none"
        >キャンセル</v-btn
      >-->
      <!--<v-btn block x-large class="wide-btn" @touchstart="resetMap"
        >地図を元に戻す</v-btn
      >-->
      <div style="height: 10vw"></div>
      <!--<v-textarea
        solo
        label="ステータス"
        :value="status"
        style="display: none"
      ></v-textarea
      ><br />
      {{ busLatLng }}<br />
      errorMSG:{{ errorMSG }}<br />
      center:{{ center }}<br />-->
    </div>
  </div>
</template>

<script>
import store from "../store";
import Export from "../export";
import router from "../vue-router/index";
import Map from "./Map";
import { latLng, latLngBounds } from "leaflet";
export default {
  components: {
    Map,
  },
  async mounted() {
    if (this.driverMode == null) {
      clearInterval(this.getMobilityDataTimerId);
      router.push("/");
    } else {
      /*var txt =
        "Client page started with bus stop id " + this.currentBusStopId + ".";
      await Export.postMail(txt, store.state.mail);*/
      if (this.homeLat == null || this.homeLon == null) {
        this.setHomeMsgDialog = true;
        /*this.btmMsg =
          "自宅を登録します。地図をスクロール、拡大／縮小して赤い十字を自宅の場所に合わせて【設定】を押してください。";
      } else {
        this.btmMsg =
          "予約する場合は、行先のバス停アイコンをタップしてください。予約ダイアログが表示されます。";*/
      }
    }
    this.makeDateList();
    var name = this.getCookie("name");
    var tel = this.getCookie("tel");
    var reservation = this.getCookie("reservation");
    if (reservation == null) {
      this.reservation = {
        id: null,
        location_name: null,
        destination_name: null,
        reserve_at: null,
      };
    }
    if (name == null) {
      this.name = "";
    } else {
      this.name = name;
    }
    if (tel == null) {
      this.tel = "";
    } else {
      this.tel = tel;
    }
    var requestingId = this.getCookie("requestingId");
    if (requestingId != null) {
      var getOrders = await Export.getOrders(requestingId);
      if (getOrders.data.order_status == "07") {
        this.nowRequesting = false;
        this.requestingId = null;
        this.$cookies.remove("requestingId");
        this.initOrder();
        this.reservation = {
          id: null,
          location_name: null,
          destination_name: null,
          reserve_at: null,
        };
        this.$cookies.set("reservation", this.reservation, 60 * 60 * 24 * 365);
      }
      if (getOrders.data.order_status == "06") {
        reservation = {
          id: getOrders.data.id,
          location_name: getOrders.data.location_name,
          destination_name: getOrders.data.destination_name,
          reserve_at: getOrders.data.reserve_at,
        };
        this.reservation = reservation;
        var reserve_at = new Date(getOrders.data.reserve_at);
        var reserve_at_timestamp = reserve_at.getTime();
        this.reserve_at_timestamp = reserve_at_timestamp;
        var now = new Date();
        var now_timestamp = now.getTime();
        var period = Math.round((reserve_at_timestamp - now_timestamp) / 1000);
        period = period + 600; //10分プラス
        this.$cookies.set("reservation", this.reservation, period);
        this.nowRequesting = false;
        this.initOrder();
        if (this.reservation.location_name != undefined) {
          var n = this.reservation.location_name.lastIndexOf("　");
          this.reservation.location_name = this.reservation.location_name.slice(
            n + 1
          );
        }
      }
    }
    if (this.reservation.id != null) {
      //this.checkReservation();
      this.getReservationCookieInterval = setInterval(async () => {
        var reservation = this.getCookie("reservation");
        if (reservation == null) {
          this.reservation = {
            id: null,
            location_name: null,
            destination_name: null,
            reserve_at: null,
          };
          clearInterval(this.getReservationCookieInterval);
        }
      }, 60000);
    }
  },
  data() {
    return {
      displayMap: true,
      status: "",
      callMobilityBtnDisabled: false,
      numToRideSelected: 0,
      dialog: false,
      dialog2: false,
      setHomeDialog: false,
      setHomeMsgDialog: false,
      markerClickDialog: false,
      markerClickDialogTitle: "",
      setHomeMsg: false,
      msgTxt: "",
      msgDisplay: "none",
      loadingOverlay: true,
      isAnim1: false,
      interval1: null,
      isAnim2: false,
      interval2: null,
      isAnim3: false,
      interval3: null,
      isAnim4: false,
      interval4: null,
      isAnim5: false,
      interval5: null,
      kurumaisu_icon: require("@/assets/kurumaisu_icon_off.png"),
      numKaigo: 0,
      guide_01: new Audio(require("@/assets/guide_call2.mp3")),
      guide_cancel: new Audio(require("@/assets/guide_cancel.mp3")),
      guide_arrival: new Audio(require("@/assets/guide_arrival.mp3")),
      btn_se: new Audio(require("@/assets/btn.mp3")),
      name: "",
      tel: "",
      age: "",
      sex: "",
      numToRide: 1,
      numToRideList: [
        { title: "1人", value: 1 },
        { title: "2人", value: 2 },
        { title: "3人", value: 3 },
        //{ title: "4人", value: 4 },
      ],
      getOn: null,
      getOff: null,
      dateList: [],
      selectedDate: null,
      timeList: [
        { text: "08:00", value: "T08:00:00+09:00" },
        { text: "08:30", value: "T08:30:00+09:00" },
        { text: "09:00", value: "T09:00:00+09:00" },
        { text: "09:30", value: "T09:30:00+09:00" },
        { text: "10:00", value: "T10:00:00+09:00" },
        { text: "10:30", value: "T10:30:00+09:00" },
        { text: "11:00", value: "T11:00:00+09:00" },
        { text: "11:30", value: "T11:30:00+09:00" },
        { text: "12:00", value: "T12:00:00+09:00" },
        { text: "12:30", value: "T12:30:00+09:00" },
        { text: "13:00", value: "T13:00:00+09:00" },
        { text: "13:30", value: "T13:30:00+09:00" },
        { text: "14:00", value: "T14:00:00+09:00" },
        { text: "14:30", value: "T14:30:00+09:00" },
        { text: "15:00", value: "T15:00:00+09:00" },
        { text: "15:30", value: "T15:30:00+09:00" },
        { text: "16:00", value: "T16:00:00+09:00" },
        { text: "16:30", value: "T16:30:00+09:00" },
        { text: "17:00", value: "T17:00:00+09:00" },
        { text: "17:30", value: "T17:30:00+09:00" },
      ],
      ageList: [
        { text: "19歳以下", value: "19歳以下" },
        { text: "20代", value: "20代" },
        { text: "30代", value: "30代" },
        { text: "40代", value: "40代" },
        { text: "50代", value: "50代" },
        { text: "60代", value: "60代" },
        { text: "70代", value: "70代" },
        { text: "80代以上", value: "80代以上" },
      ],
      sexList: [
        { text: "男性", value: "男性" },
        { text: "女性", value: "女性" },
        { text: "答えたくない", value: "答えたくない" },
      ],
      selectedTime: null,
      msgBox: false,
      msgBoxTxt: "",
      setNext: false,
      nowRequesting: false,
      requestingLoading: false,
      getOrdersInterval: null,
      getOrdersInterval2: null,
      canselOrderDialog: false,
      orderComfirmDialog: false,
      getReservationCookieInterval: null,
    };
  },
  watch: {
    nowRequestingId() {
      if (this.nowRequestingId != null) {
        this.callMobilityBtnDisabled = true;
      } else {
        this.callMobilityBtnDisabled = false;
      }
    },
    hour() {
      if (
        this.hour < this.businessHoursStart ||
        this.hour >= this.businessHoursEnd
      ) {
        this.nowRequestingId = null;
        this.comingMobility = null;
        this.comingMobilities = [];
        this.comingRequests = [];
        this.inBreakMobilities = [];
        this.timeoutDialog = false;
        clearInterval(this.getMobilityDataTimerId);
        router.push("/standby");
      }
    },
    outOfService() {
      if (this.outOfService == true) {
        this.nowRequestingId = null;
        this.comingMobility = null;
        this.comingMobilities = [];
        this.comingRequests = [];
        this.inBreakMobilities = [];
        this.timeoutDialog = false;
        clearInterval(this.getMobilityDataTimerId);
        router.push("/outOfService");
      }
    },
    operationCommand() {
      if (this.operationCommand.outOfService == "true") {
        this.outOfService = true;
      }
      if (this.operationCommand.restart == "true") {
        var clientIds = JSON.parse(this.operationCommand.clientIds);
        if (clientIds.indexOf(String(this.currentBusStopId)) != -1) {
          this.restart();
        }
        if (this.currentBusStopId == null) {
          if (clientIds.indexOf("null") != -1) {
            this.restart();
          }
        }
      }
    },
    comingMobility() {
      if (this.comingMobility != null) {
        this.msgDisplay = "block";
        this.updateMsgTxt();
      } else {
        this.msgDisplay = "none";
      }
    },
    mobilityData() {
      if (this.comingMobility != null) {
        this.updateMsgTxt();
      }
    },
    numToRideSelected() {
      if (this.numToRideSelected != null) {
        this.kurumaisu_icon = require("@/assets/kurumaisu_icon_off.png");
      }
    },
    /*busStopToGo() {
      this.markerClickDialogTitle = this.busStopToGo.name;
      this.markerClickDialog = true;
    },*/
    numToRide() {
      if (Number(this.numToRide) > 4) {
        this.numToRide = 4;
      }
      if (Number(this.numToRide) < 1) {
        alert();
        this.numToRide = 1;
      }
    },
    nowRequesting() {
      if (this.nowRequesting == true) {
        this.requestingLoading = true;
        this.getOrdersInterval = setInterval(async () => {
          await this.getOrders(this.requestingId);
        }, 5000);
      } else {
        this.requestingLoading = false;
      }
    },
  },
  methods: {
    updateMsgTxt() {
      var mobilityData = this.mobilityData;
      var lat1 = 0;
      var lng1 = 0;
      var lat2 = 0;
      var lng2 = 0;
      var status = "";
      for (var i = 0; i < mobilityData.length; i++) {
        if (mobilityData[i].id == this.comingMobility) {
          lat1 = mobilityData[i].lat;
          lng1 = mobilityData[i].lon;
          status = mobilityData[i].status;
        }
      }
      var currentBusStopId = this.currentBusStopId;
      for (i = 0; i < this.busStopList.length; i++) {
        if (this.busStopList[i].id == currentBusStopId) {
          lat2 = this.busStopList[i].latlon_lat;
          lng2 = this.busStopList[i].latlon_lon;
        }
      }
      var distance = this.getDistance(lat1, lng1, lat2, lng2);
      var m = this.distanceToTime(distance);
      if (distance < 0.03 || status == "arrive") {
        this.comingMobility = null;
        //var guide_01 = new Audio(require("@/assets/guide_arrival.mp3"));
        this.guide_arrival.currentTime = 0;
        this.guide_arrival.play();
      } else {
        if (this.comingMobilities[0] != undefined) {
          if (m == 0) {
            this.msgTxt =
              "車両（" +
              this.mobilityId2name(this.comingMobilities[0]) +
              "）が向かっています。\nまもなく到着します。";
          } else {
            this.msgTxt =
              "車両（" +
              this.mobilityId2name(this.comingMobilities[0]) +
              "）が向かっています。\nあと約" +
              m +
              "分で到着します。";
          }
        } else {
          //this.msgDisplay = "none";
          //this.comingMobility = null;
        }
      }
    },
    getDistance(lat1, lng1, lat2, lng2) {
      const R = Math.PI / 180;
      lat1 *= R;
      lng1 *= R;
      lat2 *= R;
      lng2 *= R;
      return (
        6371 *
        Math.acos(
          Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) +
            Math.sin(lat1) * Math.sin(lat2)
        )
      );
    },
    distanceToTime(km) {
      var speed = 8; //km/h 20231021 10→8km/hに変更
      var m = (60 / speed) * km;
      m = Math.round(m);
      return m;
    },
    resetMap() {
      this.displayMap = false;
      this.$nextTick(() => {
        this.displayMap = true;
      });
    },
    async inputNumToRide() {
      //var guide_01 = new Audio(require("@/assets/guide_01.mp3"));
      //await this.playBtnSe();

      this.guide_01.currentTime = 0;
      this.guide_01.play();
      if (this.isAnim1 === true || this.interval1 !== null) {
        return;
      }
      this.isAnim1 = true;
      this.interval1 = setInterval(() => {
        this.isAnim1 = false;
        clearInterval(this.interval1);
        this.interval1 = null;
      }, 500);
    },
    async callMobility() {
      if (this.isAnim1 === true || this.interval1 !== null) {
        return;
      }
      this.isAnim1 = true;
      this.interval1 = setInterval(() => {
        this.isAnim1 = false;
        clearInterval(this.interval1);
        this.interval1 = null;
      }, 500);
      if (this.numToRideSelected != null) {
        this.dialog = false;
        var busStopId = this.currentBusStopId;
        var timestamp = Date.now();
        var accepted = "";
        var canceled = "false";
        let formdata = new URLSearchParams();
        formdata.append("busStopId", busStopId);
        formdata.append("timestamp", timestamp);
        formdata.append("accepted", accepted);
        formdata.append("canceled", canceled);
        formdata.append("numToRide", this.numToRideSelected + 1);
        /*var postRequestData = await Export.postRequestData(formdata);
        this.status =
          this.timestampToTime(postRequestData.data[0].timestamp) +
          " 呼び出し中";
        this.nowRequestingId = postRequestData.data[0].id;
        this.numToRideSelected = 0;*/
      } else {
        this.dialog = false;
        this.dialog2 = true;
      }
    },
    async callMobility2() {
      if (this.isAnim1 === true || this.interval1 !== null) {
        return;
      }
      this.isAnim1 = true;
      this.interval1 = setInterval(() => {
        this.isAnim1 = false;
        clearInterval(this.interval1);
        this.interval1 = null;
      }, 500);
      this.dialog2 = false;
      var busStopId = this.currentBusStopId;
      var timestamp = Date.now();
      var accepted = "";
      var canceled = "false";
      let formdata = new URLSearchParams();
      formdata.append("busStopId", busStopId);
      formdata.append("timestamp", timestamp);
      formdata.append("accepted", accepted);
      formdata.append("canceled", canceled);
      formdata.append("numToRide", this.numKaigo + 3);
      var postRequestData = await Export.postRequestData(formdata);
      this.status =
        this.timestampToTime(postRequestData.data[0].timestamp) + " 呼び出し中";
      this.nowRequestingId = postRequestData.data[0].id;
      this.numToRideSelected = 0;
      this.kurumaisu_icon = require("@/assets/kurumaisu_icon_off.png");
      this.numKaigo = 0;
    },
    selectKurumaisuIcon() {
      this.kurumaisu_icon = require("@/assets/kurumaisu_icon_on.png");
      this.numToRideSelected = null;
    },
    async cancelRequest() {
      //await this.playBtnSe();
      var id = this.nowRequestingId;
      await Export.cancelRequest(id);
      this.comingMobility = null;
      this.nowRequestingId = null;
      //var guide_cancel = new Audio(require("@/assets/guide_cancel.mp3"));
      this.guide_cancel.currentTime = 0;
      this.guide_cancel.play();
    },
    timestampToTime(timestamp) {
      var d = Date(timestamp);
      d = new Date(d);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    mobilityId2name(id) {
      for (var i = 0; i < this.mobilityData.length; i++) {
        if (this.mobilityData[i].id == id) {
          return this.mobilityData[i].name;
        }
      }
    },
    playBtnSe() {
      this.btn_se.currentTime = 0;
      this.btn_se.play();
      this.btn_se = new Audio(require("@/assets/btn.mp3"));
    },
    restart() {
      location.reload();
    },
    setHome() {
      this.btmMsg =
        "予約する場合は、行先のバス停アイコンをタップしてください。予約ダイアログが表示されます。";
      this.$cookies.set("homeLat", this.crossLatlon.lat, 60 * 60 * 24 * 365);
      this.$cookies.set("homeLon", this.crossLatlon.lon, 60 * 60 * 24 * 365);
      this.homeLat = this.crossLatlon.lat;
      this.homeLon = this.crossLatlon.lon;
      this.setHomeDialog = false;
    },
    getNow() {
      var date = new Date();
      //var year = date.getFullYear(); // 年
      //var month = date.getMonth() + 1; // 月
      //var day = date.getDate(); // 日
      var hour = date.getHours(); // 時
      var minute = date.getMinutes(); // 分
      //var second = date.getSeconds(); // 秒
      var dayOfWeek = date.getDay(); // 曜日(数値)
      var dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]; // 曜日(日本語表記)
      this.dayOfWeek = dayOfWeek;
      this.dayOfWeekStr = dayOfWeekStr;
      this.hour = hour;
      this.minute = minute;
    },

    makeDateList() {
      this.getNow();
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };
      this.dateList = [];
      var today = new Date();
      var todayFormat = today.toLocaleDateString("sv-SE");
      var todayTxt = today.toLocaleDateString("ja-JP", options);
      var item = {
        text: todayTxt,
        value: todayFormat,
      };
      this.selectedDate = item;
      this.dateList.push(item);
      var tomorrow = new Date(today.setDate(today.getDate() + 1));
      var tomorrowFormat = tomorrow.toLocaleDateString("sv-SE");
      var tomorrowTxt = tomorrow.toLocaleDateString("ja-JP", options);
      item = {
        text: tomorrowTxt,
        value: tomorrowFormat,
      };
      this.dateList.push(item);
      var dayAfterTomorrow = new Date(today.setDate(today.getDate() + 1));
      var dayAfterTomorrowFormat = dayAfterTomorrow.toLocaleDateString("sv-SE");
      var dayAfterTomorrowTxt = dayAfterTomorrow.toLocaleDateString(
        "ja-JP",
        options
      );
      item = {
        text: dayAfterTomorrowTxt,
        value: dayAfterTomorrowFormat,
      };
      this.dateList.push(item);
      //時間リスト生成
      var allTimeList = [
        { text: "08:00", value: "T08:00:00+09:00", hour: 8 },
        { text: "08:30", value: "T08:30:00+09:00", hour: 8 },
        { text: "09:00", value: "T09:00:00+09:00", hour: 9 },
        { text: "09:30", value: "T09:30:00+09:00", hour: 9 },
        { text: "10:00", value: "T10:00:00+09:00", hour: 10 },
        { text: "10:30", value: "T10:30:00+09:00", hour: 10 },
        { text: "11:00", value: "T11:00:00+09:00", hour: 11 },
        { text: "11:30", value: "T11:30:00+09:00", hour: 11.5 },
        { text: "12:00", value: "T12:00:00+09:00", hour: 12 },
        { text: "12:30", value: "T12:30:00+09:00", hour: 12.5 },
        { text: "13:00", value: "T13:00:00+09:00", hour: 13 },
        { text: "13:30", value: "T13:30:00+09:00", hour: 13.5 },
        { text: "14:00", value: "T14:00:00+09:00", hour: 14 },
        { text: "14:30", value: "T14:30:00+09:00", hour: 14.5 },
        { text: "15:00", value: "T15:00:00+09:00", hour: 15 },
        { text: "15:30", value: "T15:30:00+09:00", hour: 15.5 },
        { text: "16:00", value: "T16:00:00+09:00", hour: 16 },
        { text: "16:30", value: "T16:30:00+09:00", hour: 16.5 },
        { text: "17:00", value: "T17:00:00+09:00", hour: 17 },
        //{ text: "17:30", value: "T17:30:00+09:00", hour: 17.5 },
      ];
      var nowHour = this.hour;
      if (this.minute >= 30) {
        nowHour += 0.5;
      }
      this.timeList = [];
      for (var i = 0; i < allTimeList.length; i++) {
        if (allTimeList[i].hour > nowHour + 0.5 && nowHour >= 7) {
          this.timeList.push(allTimeList[i]);
        }
      }
    },
    swap() {
      var tempGetOn = this.getOn;
      var tempGetOff = this.getOff;
      this.getOn = tempGetOff;
      this.getOff = tempGetOn;
    },
    saveNameTel() {
      this.$cookies.set("name", this.name, 60 * 60 * 24 * 365);
      this.$cookies.set("tel", this.tel, 60 * 60 * 24 * 365);
    },
    getCookie(key) {
      return this.$cookies.get(key);
    },
    homeClick() {
      if (
        this.nowRequesting == false &&
        this.requestingId == null &&
        this.reservation.id == null
      ) {
        this.makeDateList(); //当日設定
        if (this.setNext == true) {
          if (this.getOn == "自宅" || this.getOff == "自宅") {
            alert("乗車場所と降車場所を同じ地点には設定できません。");
          } else {
            if (this.getOn == null) {
              this.getOn = "自宅";
            }
            if (this.getOff == null) {
              this.getOff = "自宅";
            }
            this.msgBox = false;
            this.dialog = true;
          }
        } else {
          this.markerClickDialogTitle = "自宅";
          this.markerClickDialog = true;
        }
      }
    },
    busStopClick() {
      if (
        this.nowRequesting == false &&
        this.requestingId == null &&
        this.reservation.id == null
      ) {
        this.makeDateList(); //当日設定
        if (this.setNext == true) {
          if (
            this.getOn == this.busStopToGo.name ||
            this.getOff == this.busStopToGo.name
          ) {
            alert("乗車場所と降車場所を同じ地点には設定できません。");
          } else {
            if (this.getOn == null) {
              this.getOn = this.busStopToGo.name;
            }
            if (this.getOff == null) {
              this.getOff = this.busStopToGo.name;
            }
            this.msgBox = false;
            this.dialog = true;
          }
        } else {
          this.markerClickDialogTitle = this.busStopToGo.name;
          this.markerClickDialog = true;
        }
      }
    },
    cancelSetHome() {
      this.markerClickDialog = false;
      this.msgBox = false;
      this.markerClickDialogTitle = "";
      this.setNext = false;
    },
    cancelOrder() {
      this.dialog = false;
      this.initOrder();
    },
    backToHome() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            let coords = position.coords;
            // 緯度経度だけ取得
            var homeLatitude = coords.latitude;
            var homeLongitude = coords.longitude;
            var d = 10000;
            for (var i = 0; i < this.busStopList.length; i++) {
              var distance = this.getDistance(
                homeLatitude,
                homeLongitude,
                this.busStopList[i].latlon_lat,
                this.busStopList[i].latlon_lon
              );
              if (d > distance) {
                this.busStopToGo = this.busStopList[i];
                d = distance;
              }
            }
            this.getOn = "自宅";
            this.getOff = this.busStopToGo.name;
            this.dialog = true;
            this.$nextTick(() => {
              this.swap();
            });
          }.bind(this),
          function (error) {
            alert("現在位置の取得に失敗しました。Error:" + error);
          }
        );
      } else {
        // エラー処理を書く
      }
    },
    markerClickDialogBtn(from, to) {
      this.setNext = true;
      if (from == "") {
        this.getOff = to;
        this.msgBoxTxt =
          "乗車場所→" + to + "\n乗車場所のマーカーをタップしてください。";
      } else {
        this.getOn = from;
        this.msgBoxTxt =
          from + "→降車場所\n降車場所のマーカーをタップしてください。";
      }
      this.msgBox = true;
    },
    busStopName2Lat(name) {
      var lat = "";
      for (var i = 0; i < this.busStopList.length; i++) {
        if (this.busStopList[i].name == name) {
          lat = this.busStopList[i].latlon_lat;
        }
      }
      return lat;
    },
    busStopName2Lon(name) {
      var lon = "";
      for (var i = 0; i < this.busStopList.length; i++) {
        if (this.busStopList[i].name == name) {
          lon = this.busStopList[i].latlon_lon;
        }
      }
      return lon;
    },
    orderComfirm() {
      var alertTxt = "必須項目が入力されていません。";
      if (
        this.selectedDate == null ||
        this.selectedTime == null ||
        this.name == "" ||
        this.tel == ""
      ) {
        alert(alertTxt);
      } else {
        this.orderComfirmDialog = true;
      }
    },
    async postOrder() {
      this.dialog = false;
      this.orderComfirmDialog = false;
      if (this.getOn == "自宅") {
        var location_lat = this.homeLat;
        var location_lng = this.homeLon;
      } else {
        location_lat = this.busStopName2Lat(this.getOn);
        location_lng = this.busStopName2Lon(this.getOn);
      }
      if (this.getOff == "自宅") {
        var destination_lat = this.homeLat;
        var destination_lng = this.homeLon;
      } else {
        destination_lat = this.busStopName2Lat(this.getOff);
        destination_lng = this.busStopName2Lon(this.getOff);
      }
      /*var msg =
        "乗車人数:" +
        this.numToRide +
        ",性別:" +
        this.sex.value +
        ",年齢:" +
        this.age.value;*/
      var msg = "乗車人数:" + this.numToRide;
      var reserve_at = this.selectedDate.value + this.selectedTime.value;
      var postOrders = await Export.postOrders(
        this.tel,
        this.name,
        this.getOn,
        location_lat,
        location_lng,
        this.getOff,
        destination_lat,
        destination_lng,
        reserve_at,
        msg
      );
      if (Number(postOrders.status) == 200) {
        this.requestingId = postOrders.data.id;
        this.$cookies.set("requestingId", this.requestingId, 60 * 60 * 24 * 3); //3日間保存
        this.nowRequesting = true;
      } else {
        var alertTxt =
          "エラーが発生しました(" +
          postOrders.status +
          ")" +
          postOrders.statusText;
        alert(alertTxt);
      }
    },
    async getOrders(id) {
      var getOrders = await Export.getOrders(id);
      if (getOrders.data.order_status == "06") {
        clearInterval(this.getOrdersInterval);
        var reservation = {
          id: id,
          location_name: this.getOn,
          destination_name: this.getOff,
          reserve_at: getOrders.data.reserve_at,
        };
        this.reservation = reservation;
        var reserve_at = new Date(getOrders.data.reserve_at);
        var reserve_at_timestamp = reserve_at.getTime();
        this.reserve_at_timestamp = reserve_at_timestamp;
        var now = new Date();
        var now_timestamp = now.getTime();
        var period = Math.round((reserve_at_timestamp - now_timestamp) / 1000);
        period = period + 600; //10分プラス
        this.$cookies.set("reservation", this.reservation, period);
        alert("予約が確定しました。");
        this.nowRequesting = false;
        this.initOrder();
      }
      if (getOrders.data.order_status == "07") {
        clearInterval(this.getOrdersInterval);
        this.nowRequesting = false;
        alert("予約が取れませんでした。時間を変更して再度予約してください。");
        this.initOrder();
        this.reservation = {
          id: null,
          location_name: null,
          destination_name: null,
          reserve_at: null,
        };
        this.$cookies.set("reservation", this.reservation, 60 * 60 * 24 * 365);
      }
    },
    initOrder() {
      this.setNext = false;
      this.numToRide = 1;
      this.getOn = null;
      this.getOff = null;
      this.selectedDate = null;
      this.selectedTime = null;
      this.nowRequesting = false;
      this.requestingId = null;
      this.markerClickDialogTitle = "";
    },
    async checkReservation() {
      var getOrders = await Export.getOrders(this.reservation.id);
      if (getOrders.data.order_status == "06") {
        //this.reserve_getOn=g
      }
    },
    async deleteOrder() {
      var deleteOrders = await Export.deleteOrders(this.reservation.id);
      if (deleteOrders.status == 200) {
        alert("予約取消を受け付けました。");
        this.nowRequesting = false;
        this.requestingId = null;
        this.$cookies.remove("requestingId");
        this.initOrder();
        this.reservation = {
          id: null,
          location_name: null,
          destination_name: null,
          reserve_at: null,
        };
        this.$cookies.set("reservation", this.reservation, 60 * 60 * 24 * 365);
        this.canselOrderDialog = false;
      } else {
        alert(
          "予約取消に失敗しました。(" +
            deleteOrders.status +
            ":" +
            deleteOrders.statusText +
            ")"
        );
        this.canselOrderDialog = false;
      }
    },
    reserve_at2text(reserve_at) {
      var ymd = new Date(new Date(reserve_at)).toLocaleDateString("ja-JP");
      var time = new Date(new Date(reserve_at)).toLocaleTimeString("ja-JP", {
        hour12: false,
      });
      return ymd + " " + time;
    },
  },
  computed: {
    driverMode: {
      get() {
        return store.state.driverMode;
      },
      set(value) {
        store.state.driverMode = value;
      },
    },
    dayOfWeek: {
      get() {
        return store.state.dayOfWeek;
      },
      set(value) {
        store.state.dayOfWeek = value;
      },
    },
    dayOfWeekStr: {
      get() {
        return store.state.dayOfWeekStr;
      },
      set(value) {
        store.state.dayOfWeekStr = value;
      },
    },
    hour: {
      get() {
        return store.state.hour;
      },
      set(value) {
        store.state.hour = value;
      },
    },
    minute: {
      get() {
        return store.state.minute;
      },
      set(value) {
        store.state.minute = value;
      },
    },
    businessHoursStart: {
      get() {
        return store.state.businessHoursStart;
      },
      set(value) {
        store.state.businessHoursStart = value;
      },
    },
    businessHoursEnd: {
      get() {
        return store.state.businessHoursEnd;
      },
      set(value) {
        store.state.businessHoursEnd = value;
      },
    },
    center: {
      get() {
        var center = [store.state.center_lat, store.state.center_lon];
        return center;
      },
      set(value) {
        store.state.center_lat = value.lat;
        store.state.center_lon = value.lng;
      },
    },
    bounds() {
      var latLng = [];
      for (var i = 0; i < this.busStopList.length; i++) {
        latLng.push([
          Number(this.busStopList[i].latlon_lat),
          Number(this.busStopList[i].latlon_lon),
        ]);
      }
      var bounds = latLngBounds(latLng);
      return bounds;
    },
    busStopList: {
      get() {
        return store.state.busStopList;
      },
      set(value) {
        store.state.busStopList = value;
      },
    },
    busStop() {
      var busStop = [];
      for (var i = 0; i < this.busStopList.length; i++) {
        busStop.push({
          id: this.busStopList[i].id,
          name: this.busStopList[i].name,
          latlon: latLng(
            Number(this.busStopList[i].latlon_lat),
            Number(this.busStopList[i].latlon_lon)
          ),
          titles: this.busStopList[i].titles,
        });
      }
      return busStop;
    },
    busLatLng: {
      get() {
        var busLatLng = [
          store.state.busLatLng_lat_1,
          store.state.busLatLng_lon_1,
        ];
        return busLatLng;
      },
      set(value) {
        store.state.busLatLng = value;
      },
    },
    busHeading_1: {
      get() {
        return store.state.busHeading_1;
      },
      set(value) {
        store.state.busHeading_1 = value;
      },
    },
    busRotationAngle_1() {
      return this.busHeading_1 + 90;
    },
    busSpeed_1: {
      get() {
        return store.state.busSpeed_1;
      },
      set(value) {
        store.state.busSpeed_1 = value;
      },
    },
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
    currentBusStopName() {
      var name = "";
      for (var i = 0; i < this.busStop.length; i++) {
        if (this.busStop[i].id == this.currentBusStopId) {
          name = this.busStop[i].name;
        }
      }
      return name;
    },
    errorMSG: {
      get() {
        return store.state.errorMSG;
      },
      set(value) {
        store.state.errorMSG = this.errorMSG += value;
      },
    },
    nowRequestingId: {
      get() {
        return store.state.nowRequestingId;
      },
      set(value) {
        store.state.nowRequestingId = value;
      },
    },
    comingMobility: {
      get() {
        return store.state.comingMobility;
      },
      set(value) {
        store.state.comingMobility = value;
      },
    },
    comingMobilities: {
      get() {
        return store.state.comingMobilities;
      },
      set(value) {
        store.state.comingMobilities = value;
      },
    },
    mobilityData: {
      get() {
        return store.state.mobilityData;
      },
      set(value) {
        store.state.mobilityData = value;
      },
    },
    timeoutDialog: {
      get() {
        return store.state.timeoutDialog;
      },
      set(value) {
        store.state.timeoutDialog = value;
      },
    },
    getMobilityDataTimerId: {
      get() {
        return store.state.getMobilityDataTimerId;
      },
      set(value) {
        store.state.getMobilityDataTimerId = value;
      },
    },
    outOfService: {
      get() {
        return store.state.outOfService;
      },
      set(value) {
        store.state.outOfService = value;
      },
    },
    operationCommand: {
      get() {
        return store.state.operationCommand;
      },
      set(value) {
        store.state.operationCommand = value;
      },
    },
    busStopToGo: {
      get() {
        return store.state.busStopToGo;
      },
      set(value) {
        store.state.busStopToGo = value;
      },
    },
    homeLat: {
      get() {
        return store.state.homeLat;
      },
      set(value) {
        store.state.homeLat = value;
      },
    },
    homeLon: {
      get() {
        return store.state.homeLon;
      },
      set(value) {
        store.state.homeLon = value;
      },
    },
    btmMsg: {
      get() {
        return store.state.btmMsg;
      },
      set(value) {
        store.state.btmMsg = value;
      },
    },
    crossLatlon: {
      get() {
        return store.state.crossLatlon;
      },
      set(value) {
        store.state.crossLatlon = value;
      },
    },
    fee() {
      return Number(this.numToRide) * 300 + "円";
    },
    reserve_at_timestamp: {
      get() {
        return store.state.reserve_at_timestamp;
      },
      set(value) {
        store.state.reserve_at_timestamp = value;
      },
    },
    reservation: {
      get() {
        return store.state.reservation;
      },
      set(value) {
        store.state.reservation = value;
      },
    },
    selectedDateTime() {
      if (this.selectedDate != null && this.selectedTime != null) {
        return this.selectedDate.text + this.selectedTime.text;
      } else {
        return "";
      }
    },
    sexText() {
      if (this.sex != null) {
        return this.sex.text;
      } else {
        return "";
      }
    },
    ageText() {
      if (this.age != null) {
        return this.age.text;
      } else {
        return "";
      }
    },
    requestingId: {
      get() {
        return store.state.requestingId;
      },
      set(value) {
        store.state.requestingId = value;
      },
    },
    selectedDateText() {
      if (this.selectedDate != null) {
        return this.selectedDate.text;
      } else {
        return null;
      }
    },
  },
};
</script>
<style>
.wide-btn {
  font-size: 30px !important;
  font-weight: bold !important;
  margin: 10px 0;
}
.ctr {
  position: fixed;
  bottom: 0;
  z-index: 20;
  width: 100vw;
  height: 15vh;
  padding: 3vw;
  text-align: left;
  background: #fff;
}
.msg {
  position: fixed;
  top: 60px;
  z-index: 20;
  width: 100vw;
  padding: 10px;
}
.msg .msgTxt {
  background: #ffffffbb;
  width: 100%;
  padding: 20px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.call_btn {
  /*width: 160px;*/
  width: 33vw;
}
.fix_btn {
  /*width: 160px;*/
  width: 33vw;
}
.rideNumInput .v-btn {
  width: 95vw !important;
  margin: 100vw auto 5vw;
  border-radius: 20px !important;
  font-size: 30px;
}
.rideNumInput .v-btn .nin {
  font-size: 15px;
  margin-top: 10px;
}
.loadingOverlayTxt {
  font-size: 35px;
  font-weight: bold;
}
.kurumaisu_icon {
  height: 80px;
  width: auto;
  margin: 5px 0 0 5px;
}
.animation {
  animation-direction: normal;
  animation-duration: 0.5s;
  animation-name: anim_sc;
  animation-timing-function: ease;
  transform: scale(1, 1);
}

.formDialog .col {
  padding-top: 6px !important;
  padding-bottom: 0 !important;
}
.note {
  text-align: right;
}
@keyframes anim_sc {
  50% {
    transform: scale(0.9, 0.9);
  }

  100% {
    transform: scale(1, 1);
  }
}
.setHomeMsg {
  position: fixed;
  bottom: 0;
  z-index: 900;
  width: 96vw;
  margin: 2vw;
  background: #fff;
  padding: 4vw;
  border-radius: 6px;
  box-shadow: 6px 6px 10px 0px rgba(0, 0, 0, 0.4);
  white-space: pre-line;
}
.markerClickDialogTitle {
  display: block !important;
  text-align: center !important;
  font-weight: bold !important;
}
.reservedMsg {
  position: fixed;
  bottom: 0;
  z-index: 100;
  width: 96vw;
  margin: 2vw;
  background: #fff;
  padding: 4vw;
  border-radius: 6px;
  box-shadow: 6px 6px 10px 0px rgba(0, 0, 0, 0.4);
  white-space: pre-line;
}
</style>
